export default "__VITE_ASSET__RAcAt8PI__"